module.exports = __webpack_public_path__ + "img/xcb-subject-item-5@2x.abe14e7b.png";